import { http } from '@haohan/clw-utils'

const URL = '/api/v1/template'

export const createTemplate = (data: any): any => {
  return http.request({
    url: `${URL}/apply-new`,
    data,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const updateTemplate = (id: string, data: any): any => {
  return http.request({
    url: `${URL}/${id}/apply-modify`,
    data: data,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
/**
 * 获得模板详情
 * @param id 模板ID
 * @returns 模板详情
 */
export const getTemplate = (id: any): any => {
  return http.request({
    url: `${URL}/${id}`,
    method: 'GET'
  })
}

/**
 * 查询模板标签
 * @param data 查询模板标签参数
 * @returns 模板标签
 */
export const queryTemplateTag = (data = { page: 1, size: 10000 }): any => {
  return http.request({
    url: `/api/v1/template-tag/query`,
    data,
    method: 'POST'
  })
}
/**
 * 查询模板
 * @param data 查询模板
 * @param keyword 关键字
 * @returns 模板标签
 */
export const queryTemplate = (
  data: any,
  opts: any = { keyword: '', industryId: 0, sceneId: 0 }
): any => {
  let url = `${URL}/query`
  const { keyword, industryId, sceneId } = opts
  const queryStr = []
  if (keyword) {
    queryStr.push(`keyword=${keyword}`)
  }
  if (industryId) {
    queryStr.push(`industryId=${industryId}`)
  }
  if (sceneId) {
    queryStr.push(`sceneId=${sceneId}`)
  }
  if (queryStr.length > 0) {
    url = `${url}?${queryStr.join('&')}`
  }
  return http.request({
    url: url,
    data,
    method: 'POST'
  })
}

//模板历史记录
export const getTemplateHistory = (id: string, data: any): any => {
  return http.request({
    url: `${URL}/${id}/task/query`,
    method: 'POST',
    data: data
  })
}
/**
 * 查询模板行业
 */
export function queryTemplateIndustryListReq(data: any): any {
  return http.request({
    url: `/api/v1/template-industry/query`,
    data,
    method: 'POST'
  })
}
/**
 * 查询模板场景
 */
export function queryTemplateSceneListReq(data: any): any {
  return http.request({
    url: `/api/v1/template-scene/query`,
    data,
    method: 'POST'
  })
}

/**
 * 模板创建项目
 * @param templateId 模板id
 * @param data 创建项目数据
 */
export function createProjectByTemplate(templateId: number, data: any): any {
  return http.request({
    url: `${URL}/${templateId}/create-project`,
    data,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 删除审核模板
 * @param templateId 模板id
 */
export function deleteTemplate(templateId: number): any {
  return http.request({
    url: `${URL}/${templateId}`,
    method: 'DELETE'
  })
}

/**
 * 根据模板ID，获得项目详情
 * @param id 模板ID
 * @returns 项目详情
 */
export const getProjectByTemplate = (templateId: any): any => {
  return http.request({
    url: `/api/v1/template-invoke/${templateId}/project`,
    method: 'GET'
  })
}

/**
 * 根据模板ID，获得模块详情
 * @param id 模板ID
 * @param data 查询参数
 * @returns 模块列表
 */
export const getModulesByTemplate = (templateId: any, data: any): any => {
  return http.request({
    url: `/api/v1/template-invoke/${templateId}/modules/query`,
    data,
    method: 'POST'
  })
}

/**
 * 根据模板ID，获得菜单信息
 * @param id 模板ID
 * @param moduleId 模板ID
 * @returns 菜单列表
 */
export function getMenusByTemplate(templateId: string, moduleId: string) {
  // if (!_moduleId) return
  const _p = {
    orders: [
      {
        mode: 'ASC',
        expression: 'sort'
      }
    ]
  }
  return http.request({
    method: 'post',
    url: `/api/v1/template-invoke/${templateId}/modules/${moduleId}/menus/tree`,
    data: _p
  })
}
